import { FilterRoot } from "./FilterRoot";
import { FilterTrigger } from "./FilterTrigger";
import { FilterPopover } from "./FilterPopover";
import { FilterCategoryPicker } from "./FilterCategoryPicker";
import { FilterValuePicker } from "./FilterValuePicker";
import { FilterPillBar } from "./FilterPillBar";
import { FilterPill } from "./FilterPill";

export const Filter = Object.assign(FilterRoot, {
  Trigger: FilterTrigger,
  Popover: FilterPopover,
  CategoryPicker: FilterCategoryPicker,
  ValuePicker: FilterValuePicker,
  PillBar: FilterPillBar,
  Pill: FilterPill,
});

export { useFilter } from "./FilterContext";
export type {
  FilterCategory,
  FilterCategoryGroup,
  FilterValue,
  FilterOperator,
  ActiveFilter,
  FilterLogic,
  FilterStep,
  FilterContextType,
} from "./types";
export { FILTER_CATEGORY_GROUPS } from "./filter-data";
